import React from 'react'

export default function Phox() {
  return (
    <section className="phox">
        <h2 className='main-title'>What Shopex Offer!</h2>
        <div className="box-containe">
        <div className='box'>
        <div className="image">
                       <img src='/image/trak.png' alt="" />

                   </div>

        <div className="inner">
            <h2>24/7 Support</h2>
            
<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Massa purus gravida.</p>
        </div>
    </div>
    <div className='box'>
        <div className="image">
                       <img src='/image/hand.png' alt="" />

                   </div>

        <div className="inner">
            <h2>24/7 Support</h2>
            
<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Massa purus gravida.</p>
        </div>
    </div>
    <div className='box'>
        <div className="image">
                       <img src='/image/medal.png' alt="" />

                   </div>

        <div className="inner">
            <h2>24/7 Support</h2>
            
<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Massa purus gravida.</p>
        </div>
    </div>
    <div className='box'>
        <div className="image">
                       <img src='/image/phone.png' alt="" />

                   </div>

        <div className="inner">
            <h2>24/7 Support</h2>
            
<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Massa purus gravida.</p>
        </div>
    </div>


        </div>
    </section>
  )
}
